export default __webpack_public_path__ + "static/media/Raining_06.6cc036a2.png";